module.exports = __webpack_public_path__ + "static/media/vikram-black.88d04e69.jpg";